/**
 * Analytics and Conversion Tracking Module
 * Supports Google Analytics 4, PostHog, Microsoft Clarity, and custom conversion events.
 */

export const trackEvent = (eventName, eventParams = {}) => {
  // 1. Google Analytics 4 (gtag)
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }

  // 2. PostHog
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.capture(eventName, eventParams);
  }

  // 3. Microsoft Clarity
  if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
    window.clarity('event', eventName);
  }

  // 4. Development Console Output
  if (process.env.NODE_ENV !== 'production') {
    console.log(`[Analytics Track] ${eventName}:`, eventParams);
  }
};

export const trackPageView = (url, title) => {
  trackEvent('page_view', {
    page_location: url || window.location.href,
    page_title: title || document.title,
    page_path: window.location.pathname
  });
};

export const trackUploadStarted = (fileCount, totalSize) => {
  trackEvent('upload_started', { file_count: fileCount, total_size_bytes: totalSize });
};

export const trackUploadCompleted = (fileCount, totalPages) => {
  trackEvent('upload_completed', { file_count: fileCount, total_pages: totalPages });
};

export const trackCheckoutInitiated = (jobId, amount, pages, colorMode) => {
  trackEvent('begin_checkout', {
    transaction_id: jobId,
    value: amount,
    currency: 'INR',
    pages: pages,
    color_mode: colorMode
  });
};

export const trackPaymentCompleted = (jobId, amount, paymentMethod = 'cashfree') => {
  trackEvent('purchase', {
    transaction_id: jobId,
    value: amount,
    currency: 'INR',
    payment_method: paymentMethod
  });
};

export const trackServiceViewed = (serviceSlug, serviceName) => {
  trackEvent('view_item', {
    item_id: serviceSlug,
    item_name: serviceName,
    item_category: 'Printing Service'
  });
};
